import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritPartOneVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartOneVehicleInformation/patchCulpritPartOneVehicleInformation.type';

export const patchInitialPartOneVehicleInformationFunction = ({
  id,
  data,
}: PatchCulpritPartOneVehicleInformationType) => {
  return fetchApi.patch(
    `/initial/reports/${id}/vehicle_information/part_one/`,
    {
      ...data,
    },
  );
};
